import { useState } from "react";
import ChangeLogModal from "../../Modals/ChangeLogModal/ChangeLogModal.jsx";
import Modal from "../../Modals/Modal/Modal.jsx";
import css from "./ChangeLog.module.css";
import { useSelector } from "react-redux";
import { selectCurrentVersionChanges } from "../../../redux/changeLog/selectors.js";

export default function ChangeLog() {
  const [changeLogModalOpen, setChangeLogModalOpen] = useState(false);
  const currentVersionChanges = useSelector(selectCurrentVersionChanges);

  const handleChangeLogClick = () => {
    setChangeLogModalOpen(true);
  };

  return (
    <>
      <div
        className={`${css.changeLogBtn} ${currentVersionChanges.is_read === false ? css.highlighted : ""}`}
      >
        <span onClick={handleChangeLogClick}>
          {currentVersionChanges.is_read === false
            ? "Нова версія додатка!"
            : "Журнал змін додатка"}
        </span>
        {`Версія: ${currentVersionChanges.version}`}
      </div>
      {changeLogModalOpen && (
        <Modal
          isOpen={changeLogModalOpen}
          onClose={() => setChangeLogModalOpen(false)}
        >
          <ChangeLogModal onClose={() => setChangeLogModalOpen(false)} />
        </Modal>
      )}
    </>
  );
}
